import Ajv from "ajv";
import configSchema from "./externalConfiguration.schema.json";

// Protip:
// Creating the json schema for IExternalConfig was very easy using VS Code extension
// https://marketplace.visualstudio.com/items?itemName=marcoq.vscode-typescript-to-json-schema

export const validateConfiguration = (data: unknown) => {
  const ajv = new Ajv({strict: false});
  if (ajv.validate(configSchema, data)) {
    return [];
  } else {
    return ajv.errors;
  }
};
